import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["endDate", "endDateContainer", "discountOption", "startDate"]

  connect() {
    this.discountOptionTargets.forEach(option => {
      if (option.checked) {
        this.updateEndDate({ target: option })
      }
    })
  }

  updateEndDate(e) {
    const isOneTime = e.target.dataset.oneTime === "true"
    this.endDateTarget.value = e.target.dataset.endDate
    this.endDateContainerTarget.hidden = isOneTime
  }

  startDateChanged() {
    this.endDateTarget.value = ""
  }
}
